module.exports = "https://p.cds.unp.clasificados.pe/payment-success-employment.0b83af3ada6c98f8cad002cdf23411ff.png";